import axios from 'axios'
import { EnumResponse } from '@/api/services/common.dto'

export default class ShipmentBlockingRulesAuxiliaryService {
    async getAllShipmentBlockingCauses(): Promise<EnumResponse[]> {
        const response = await axios.get<EnumResponse[]>(`/configuration/shipmentBlockingCauses/`)
        return response.data
    }
}

export const shipmentBlockingRulesAuxiliaryService = new ShipmentBlockingRulesAuxiliaryService()
